import React from 'react';
import {
  FormSection,
  SectionHeading,
  DescriptionText,
  StyledAsterisksText,
  SubSection,
  largeInputBorderStyle,
} from '@/shared/styles/styledComponents/editProfileForm';
import { green } from '@/shared/styles/colors';
import StaticInput from '@/shared/components/StaticInput';
import ShareAgeRadio from '@/app/onboarding/components/ShareAgeRadio';

interface Props {
  sizingDetails: string;
  setSizingDetails: (value: string) => void;
  height: string;
  setHeight: (value: string) => void;
  shareAge: boolean;
  setShareAge: (value: boolean) => void;
  isDesktop: boolean;
}

const MeasurementsSection: React.FC<Props> = ({
  sizingDetails,
  setSizingDetails,
  height,
  setHeight,
  shareAge,
  setShareAge,
  isDesktop,
}) => {
  return (
    <FormSection isDesktop={isDesktop}>
      <SectionHeading isDesktop={isDesktop}>MEASUREMENTS</SectionHeading>
      <DescriptionText marginBottom={isDesktop ? 18 : 24}>
        Help your stylist recommend the best options for you.
      </DescriptionText>

      <StyledAsterisksText marginBottom={24}>
        Sizing Details (optional)
      </StyledAsterisksText>
      <SubSection>
        <StaticInput
          value={sizingDetails}
          onChange={(e) => setSizingDetails(e.nativeEvent.text)}
          placeholderText="Enter your ideal sizing information (pant, shirt, dress etc)"
          labelText="SIZING"
          showLabel
          multiline
          outlineStyle={largeInputBorderStyle}
          contentStyle={{
            paddingHorizontal: 18,
            borderRadius: 8,
            paddingBottom: 16,
            paddingTop: 16,
          }}
          customStyles={{
            minHeight: isDesktop ? 90 : 120,
            borderRadius: 8,
            color: green,
            marginBottom: 0,
          }}
        />
      </SubSection>

      <StyledAsterisksText marginBottom={24} style={{ marginTop: 24 }}>
        Height (optional)
      </StyledAsterisksText>
      <SubSection>
        <StaticInput
          value={height}
          onChange={(e) => setHeight(e.nativeEvent.text)}
          placeholderText={`Enter your height (e.g., 5' 3")`}
          labelText="HEIGHT"
          showLabel
          outlineStyle={largeInputBorderStyle}
          customStyles={{
            borderRadius: 8,
            color: green,
            marginBottom: 0,
          }}
        />
      </SubSection>

      <StyledAsterisksText marginBottom={0} style={{ marginTop: 24 }}>
        Age (optional)
      </StyledAsterisksText>
      <ShareAgeRadio value={shareAge} onValueChange={setShareAge} />
    </FormSection>
  );
};

export default MeasurementsSection;
